import { useEffect } from 'react';
import { useAppStore } from '../../../../store/appStore';
import { trackAction } from '../../../../libs/analytics/ActionTracking';
import { useGuardUnsavedGcp } from '../../../../hooks/useGuardUnsavedGcp';

export const useCloseMissionWindowOnEsc = () => {
  const { setSelectedMission } = useAppStore();
  const withGcpUnsavedChangesGuard = useGuardUnsavedGcp();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        const selectOpen = document.querySelector(
          '.any-select-open, .modal-backdrop, .mission-map-expanded, .ta-modal-overlay',
        );
        if (!selectOpen) {
          trackAction('Close mission window with Esc', null);
          withGcpUnsavedChangesGuard(() => {
            setSelectedMission(null);
          })();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [setSelectedMission, withGcpUnsavedChangesGuard]);
};
